"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importDefault(require("react"));
const react_dropzone_1 = tslib_1.__importDefault(require("react-dropzone"));
const themes_1 = require("../utils/themes");
const DragAndDrop_1 = require("src/components/sub-components/DragAndDrop");
function CsvUpload(props) {
    const borderColor = props.hasError === "* CSV file is required" ? "red" : "#949494";
    const style = Object.assign({}, themes_1.FileUploadDiv, { border: `2px dashed ${borderColor}`, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", width: "100%", marginTop: "0" });
    const textStyle = {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        fontSize: "16px",
    };
    return (react_1.default.createElement(react_dropzone_1.default, { onDrop: (acceptedFiles) => props.onChange(acceptedFiles) }, ({ getRootProps, getInputProps }) => (react_1.default.createElement("section", null,
        react_1.default.createElement("div", Object.assign({}, getRootProps(), { style: style }),
            react_1.default.createElement("input", Object.assign({}, getInputProps())),
            props.fileName === "" ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { variant: "body1", style: textStyle, component: "div" },
                    react_1.default.createElement("div", { style: { paddingBottom: '24px' } },
                        react_1.default.createElement(DragAndDrop_1.DragDrop, { color: "#868DAA" })),
                    react_1.default.createElement("span", { style: { paddingBottom: "8px", fontSize: "20px" } },
                        "Choose a file or drag & drop it here ",
                        react_1.default.createElement("br", null)),
                    react_1.default.createElement("span", { style: { fontSize: "16px", color: "#868DAA" } }, "maximum upload file size: 5MB")))) : (react_1.default.createElement(core_1.Typography, { variant: "body1", style: textStyle }, props.fileName)))))));
}
exports.CsvUpload = CsvUpload;
//# sourceMappingURL=csv-upload.js.map